(function ($) {

    $(document).ready(function () {

        $('.tb-booking-button-wrapper').closest('.section-wrapper').css('overflow', 'visible');
        $('.tb-booking-button-wrapper').closest('.section').css('overflow', 'visible');
        $('.booking-nav-wrp').closest('.section-wrapper').css('overflow', 'visible');
        $('.booking-nav-wrp').closest('.section').css('overflow', 'visible');

    });

})(jQuery);
